module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Наименование системы координат</td>\n			<td><control type=\"text\" target=\"item.identifier\"/></td>\n		</tr>\n		<tr>\n			<td>Вид проекции</td>\n			<td><control type=\"text\" target=\"item.projection\"/></td>\n		</tr>\n		<tr>\n			<td>Наименование эллипсоида</td>\n			<td><control type=\"text\" target=\"item.ellipsoid\"/></td>\n		</tr>\n		<tr>\n			<td>Исходные даты в соответствии с ГОСТ Р 52572</td>\n			<td><control type=\"text\" target=\"item.datum\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}